import React from 'react';
import ContactInfo from './ContactInfo';

const CompanyInfo: React.FC = () => {
    return (
        <div className="group">
            <div className="text-3xl font-bold text-accent mb-4 group-hover:scale-105 transition-transform duration-300">
                Eldaï
            </div>
            <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                Votre grossiste en produits casher de confiance.
                Qualité et service d'excellence depuis des années.
            </p>
            <div className="links-container">
                <ContactInfo
                    icon="📧"
                    href="mailto:contact@eldai.fr"
                    text="contact@eldai.fr"
                    isClickable={true}
                />
                <ContactInfo
                    icon="📞"
                    href="tel:0149447575"
                    text="01 49 44 75 75"
                    isClickable={true}
                />
                <ContactInfo
                    icon="📍"
                    text="Paris, France"
                />
            </div>
        </div>
    );
};

export default CompanyInfo;
